import * as React from 'react';
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';

export const renderSortIcon = ({
  sortOrder,
}: {
  sortOrder?: 'ascend' | 'descend';
}) => {
  if (sortOrder === 'ascend') {
    return <ArrowDownOutlined style={{ color: 'var(--color-text-muted, #5a6a6a)' }} />;
  }
  return <ArrowUpOutlined style={{ color: 'var(--color-text-muted, #5a6a6a)' }} />;
};
